<template>
  <div class="long-card-preload">
    <content-loader
      :height="116"
      :width="944"
      :speed="2"
      primaryColor="#f3f3f3"
      secondaryColor="#ecebeb"
    >
      <rect x="302" y="9" rx="3" ry="3" width="418.07" height="14.17" />
      <rect x="11.6" y="28.2" rx="3" ry="3" width="100" height="40" />
      <rect x="1" y="93.6" rx="3" ry="3" width="0" height="70" />
      <rect x="157" y="15.6" rx="3" ry="3" width="100" height="60" />
      <rect x="301" y="29" rx="3" ry="3" width="384" height="14.17" />
      <rect x="303" y="70.28" rx="3" ry="3" width="134.4" height="10.2" />
      <rect x="798" y="7.28" rx="3" ry="3" width="99.84" height="24.66" />
      <rect x="766" y="54.28" rx="3" ry="3" width="165.12" height="31.74" />
    </content-loader>
  </div>
</template>

<script>
export default {
  name: "LongCardPreload"
};
</script>

<style lang="scss">
.long-card-preload,
.long-card-preload svg {
  height: 116px;
  width: 100%;
}
</style>
